import { RESPONSEDATA } from "app/shared/services/services-model.type";
import { FETCH_TRANSFER_INFO_REQUEST, FETCH_TRANSFER_INFO_SUCCESS, FETCH_TRANSFER_INFO_FAILURE } from "./actions.type";
import { FetchTransferInfoRequest, FetchTransferInfoSuccess, FetchTransferInfoFailure } from "./types";

export const fetchTransferInfoRequest = (payload?: string): FetchTransferInfoRequest => ({
  type: FETCH_TRANSFER_INFO_REQUEST,
  payload,
});

export const fetchTransferInfoSuccess = (payload?: RESPONSEDATA): FetchTransferInfoSuccess => ({
  type: FETCH_TRANSFER_INFO_SUCCESS,
  payload,
});

export const fetchTransferInfoFailure = (payload?: string): FetchTransferInfoFailure => ({
  type: FETCH_TRANSFER_INFO_FAILURE,
  payload,
});
